import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const GET_BASIC_PROVIDER_INFORMATION = 'GET_BASIC_PROVIDER_INFORMATION';
export const GET_BASIC_PROVIDER_INFORMATION_SUCCESS =
  'GET_BASIC_PROVIDER_INFORMATION_SUCCESS';
export const GET_BASIC_PROVIDER_INFORMATION_FAILURE =
  'GET_BASIC_PROVIDER_INFORMATION_FAILURE';

// Action Creators
export const fetchGetBasicProviderInformation = () => ({
  type: GET_BASIC_PROVIDER_INFORMATION,
});

export const fetchGetBasicProviderInformationSuccess = (data) => ({
  type: GET_BASIC_PROVIDER_INFORMATION_SUCCESS,
  payload: data,
});

export const fetchGetBasicProviderInformationFailure = (error) => ({
  type: GET_BASIC_PROVIDER_INFORMATION_FAILURE,
  payload: error,
});

// Thunk Function
export const getBasicProviderInformationCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetBasicProviderInformation(data, external));
    try {
      const response = await getMethodWithToken(
        url.getBasicProviderInformationSuperAdmin + external?.id + '/'
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetBasicProviderInformationSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetBasicProviderInformationFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetBasicProviderInformationFailure(error.message));
    }
  };
};
